var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-indicator"},[_c('div',{class:['block', 'block-1', _vm.blockClass]}),_c('div',{class:['block', 'block-2', _vm.blockClass]}),_c('div',{class:['block', 'block-3', _vm.blockClass]})])
}
var staticRenderFns = []

export { render, staticRenderFns }